
import React from "react";
import SellerSidebar from "../components/Seller/SellerSidebar/SellerSidebar";
import SellerNavbar from "../components/Seller/SellerNavbar/SellerNavbar";
import { Navigate, Outlet } from "react-router-dom";
import { useAuth } from "../context/AuthContext";

const SellerLayout = () => {
  const { user } = useAuth();
  if (user?.is_approved === "Pending") {
    return <Navigate to="/seller/pending" replace />;
  }

  if (user?.is_approved === "Rejected") {
    return <Navigate to="/seller/rejected" replace />;
  }
  return (
    <div className="h-screen w-full flex">
      {/* Sidebar */}
      <div className="fixed left-0 top-0 hidden h-screen w-64 bg-white lg:block">
        <SellerSidebar />
      </div>

      {/* Main Content */}
      <div className="flex min-w-[960px]  flex-1 flex-col lg:ml-64">
        {/* Navbar (Fixed at Top) */}
        <div className="fixed right-0 top-0 z-10  bg-white lg:left-64">
          <SellerNavbar />
        </div>

        {/* Scrollable Outlet Content */}
        <div className="mt-16   p-6 flex-1 overflow-y-auto">
          <Outlet />
        </div>
      </div>
    </div>
  );
};

export default SellerLayout;

